import TableBase from 'components/Table/TableBase'
import { LoadingOutlined } from '@ant-design/icons'
import { useHistoryOrderUpdateWeigh } from 'services/swr/order'
import { useEffect, useState } from 'react'
import { Flex } from 'widgets/Box'
import { numberWithCommas } from 'utils'
import FilterForm from './FilterForm'
import { useHistory } from 'react-router-dom'
import * as qs from 'query-string'

const HistoryTable = () => {
  const history = useHistory()

  const [params, setParams] = useState<any>(() => {
    const query = qs.parse(location.search)
    return {
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
    }
  })

  useEffect(() => {
    const query = qs.parse(location.search)
    setParams({
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
    })
  }, [])

  useEffect(() => {
    if (params) {
      const queryString = qs.stringify(params)
      history.push({
        pathname: history.location.pathname,
        search: queryString ? `?${queryString}` : '',
      })
    }
  }, [history, params])
  const { data, isLoading } = useHistoryOrderUpdateWeigh(params)

  const columns = [
    {
      title: 'Ngày điều chỉnh',
      dataIndex: 'created_at',
      render: (value) => value,
    },
    {
      title: 'Mã đơn vận',
      dataIndex: 'order_code',
      render: (value) => (
        <p>
          {value}
        </p>
      ),
    },
    {
      title: 'Trước điều chỉnh',
      dataIndex: 'from_package',
      render: (value, item) => (
        <Flex flexDirection={'column'} alignItems={'flex-end'}>
          <p>{value}</p>
          <p>Khối lượng: {item?.weight_from}</p>
          <p>Giá vận: {numberWithCommas(item?.fee_from)}</p>
        </Flex>
      ),
    },
    {
      title: 'Sau điều chỉnh',
      dataIndex: 'to_package',
      render: (value, item) => (
        <Flex flexDirection={'column'} alignItems={'flex-end'}>
          <p>{value}</p>
          <p>Khối lượng: {item?.weight_to}</p>
          <p>Giá vận: {numberWithCommas(item?.fee_to)}</p>
        </Flex>
      ),
    },
  ]

  return (
    <>
      <FilterForm setParams={setParams} isLoading={isLoading} params={params} />

      <TableBase
        columns={columns}
        dataSource={data?.orders}
        scroll={{ x: 1000 }}
        rowKey={(row) => row.id}
        pagination={{
          current: data?.meta?.current_page,
          pageSize: data?.meta?.per_page,
          total: data?.meta?.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            if (pageSize !== data?.meta?.per_page) {
              page = 1
            }
            window.scrollTo({ top: 0, behavior: 'smooth' })
            setParams((prev) => ({
              ...prev,
              page: page,
              per_page: pageSize,
            }))
          },
          showTotal: (total) => `Tổng ${total}`,
        }}
      />
    </>
  )
}

export default HistoryTable
